import * as React from 'react';
export const bluetoothSvg = React.forwardRef(function bluetoothSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.838.057a.75.75 0 0 1 .817.163l3.272 3.272a1.25 1.25 0 0 1 0 1.767L9.185 8l2.742 2.742a1.25 1.25 0 0 1 0 1.767l-3.272 3.272a.75.75 0 0 1-1.28-.53V9.81L5.03 12.156a.75.75 0 1 1-1.06-1.061L7.064 8 3.97 4.906a.75.75 0 1 1 1.06-1.06L7.375 6.19V.75a.75.75 0 0 1 .463-.693ZM8.875 13.44l1.814-1.815-1.814-1.814v3.629Zm0-7.25 1.814-1.815-1.814-1.814V6.19Z',
    }),
  );
});
bluetoothSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bluetooth = {
  category: 'icon',
  colorable: true,
  name: 'bluetooth',
  svg: bluetoothSvg,
};
